import * as Contract from '@tableau/api-external-contract-js';
import { TableauEventType } from '@tableau/api-external-contract-js';
import { TableauWorksheetEvent } from './TableauWorksheetEvent';

export class SummaryDataChangedEvent extends TableauWorksheetEvent implements Contract.SummaryDataChangedEvent {
  public constructor(worksheet: Contract.ExtensionWorksheet) {
    super(TableauEventType.SummaryDataChanged, worksheet);
  }
}
